/** @jsx React.DOM */
// var React = require('react');

import {TableCtrl} from './components/Table'
import {CardCtrl} from './components/Card'
import {React} from 'reactjs'
import {Model} from './models'



React.initializeTouchEvents(true)

function _App(){"use strict";}

  _App.prototype.render=function() {"use strict";
    return (
      React.DOM.div({className: "table-container"}, 
        CardCtrl({ctx: new Model(), body: TableCtrl}), 
        CardCtrl({ctx: new Model(), body: TableCtrl}), 
        CardCtrl({ctx: new Model(), body: TableCtrl}), 
        CardCtrl({ctx: new Model(), body: TableCtrl})
      )
    );
  };


export var App = React.createClass(_App.prototype);

var renderApp = function() 
  {return React.renderComponent(App(null), document.getElementById('react-app'));};

renderApp();

/*


*/


//# sourceMappingURL=data:application/json;base64,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


/** WEBPACK FOOTER **
 ** ../app/index.js
 **/